import {
  FlowchartChangeGenerator,
  FlowchartValidator,
} from 'processes/graph-builder-processes/platform/FlowchartValidator';
import {
  ProcessFlowchartErrorType,
  ProcessFlowchartForValidation,
  ProcessFlowchartValidationError,
} from 'processes/graph-builder-processes/validation/ProcessFlowchartForValidationTypes';
import {ProcessFlowchartDesignSpace} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';
import {FlowchartConfigWithMetadata} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/redux/flowchartConfigAutosaveManagerCallbacks';
import {getEmptyFlowchartChanges} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/useFlowchartState/useFlowchartState';

export default class ProcedureFlowchartValidator extends FlowchartValidator {
  override validateFlowchartForType(
    flowchart: ProcessFlowchartForValidation,
    designSpace: ProcessFlowchartDesignSpace,
    didInitialFlowchartHaveChainedRouters: boolean,
    disconnectedNodeIds?: Array<string>
  ): Array<ProcessFlowchartValidationError> {
    // TODO: Implement procedure flowchart validation.
    return [];
  }

  override readonly errorTypeToMessageOverride: Partial<Record<ProcessFlowchartErrorType, string>> = {
    [ProcessFlowchartErrorType.DATA_FLOW_EDGE_WITH_NO_CONTROL_FLOW_EDGE]:
      'Materials can only flow between connected unit operations.',
  };

  override healFlowchart(): FlowchartChangeGenerator {
    return (currentFlowchart: FlowchartConfigWithMetadata) => getEmptyFlowchartChanges();
  }
}
